import { Pipe, PipeTransform } from '@angular/core';

const MS_PER_MINUTE = 60_000;
const MS_PER_HOUR = 3_600_000;
const MS_PER_DAY = 86_400_000;

export function formatDetailActivityTimestamp(timestamp: string | Date | null | undefined): string {
  if (!timestamp) return '';

  const date = new Date(timestamp);
  if (Number.isNaN(date.getTime())) return '';

  const diffMs = Date.now() - date.getTime();

  if (diffMs >= 0 && diffMs < MS_PER_DAY) {
    if (diffMs < MS_PER_HOUR) {
      const minutes = Math.max(1, Math.floor(diffMs / MS_PER_MINUTE));
      return $localize`:@@TASKS_ACTIVITY_MINUTES_AGO:${minutes}:PH_MIN: minutes ago`;
    }

    const hours = Math.floor(diffMs / MS_PER_HOUR);
    return $localize`:@@TASKS_ACTIVITY_HOURS_AGO:${hours}:PH_HOURS: hours ago`;
  }

  return formatDetailActivityDate(date);
}

function formatDetailActivityDate(date: Date): string {
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${day}.${month}.${year}`;
}

@Pipe({
  name: 'detailActivityDate',
  standalone: true
})
export class DetailActivityDatePipe implements PipeTransform {
  transform(timestamp: string | Date | null | undefined): string {
    return formatDetailActivityTimestamp(timestamp);
  }
}
